import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Hero Header element, used to display a big header with background image
 *
 * @slot - Unnamed slot (default slot)
 * @prop {String} image - mandatory, used to set the background image (url)
 * @prop {Number} height - optional, used to set the height of the hero header (default 450)
 * @prop {Boolean} noContent - optional, used to hide content card and only show image
 * @prop {Boolean} left - optional, used to display the contentcard on the leftside (default right)
 * @prop {Boolean} catalog - optional, used to display a smaller heroContent section
 */
let SDBContentHeroHeader = class SDBContentHeroHeader extends LitElement {
    constructor() {
        super(...arguments);
        this.image = '';
        this.height = 450;
        this.noContent = false;
        this.catalog = false;
        this.left = false;
    }
    render() {
        return html `
            <div
                id="heroImage"
                style="background-image:url('${this.image}');"
            ></div>
            <div id="heroContent">
                <div id="heroContentCard">
                    <slot></slot>
                </div>
            </div>
        `;
    }
    firstUpdated() {
        this.style.setProperty('--heroheight', this.height + 'px');
    }
};
SDBContentHeroHeader.styles = [
    elements,
    css `
            :host {
                height: var(--heroheight);
                display: block;
            }

            :host([noContent]) #heroContent {
                display: none;
            }

            :host #heroImage {
                position: absolute;
                display: block;
                height: calc(var(--heroheight) + 50px);
                left: var(--hero_left, 0);
                right: var(--hero_right, 0);
                border-radius: var(--hero_border-radius, 0);
                z-index: -1;
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover;
                /* background color fallback */
                background-color: var(--theme-tertiary);

                filter: var(--sdb-content-heroheader-filter);
                transform: var(--sdb-content-heroheader-transform);
                width: var(--sdb-content-heroheader-width);
            }

            :host #heroContent {
                position: relative;

                height: var(--heroheight);
                margin: 0 auto;
                max-width: 1400px;
                width: calc(100% - 60px);
                padding: 0 30px;

                display: grid;
                grid-template-rows: 40px auto 40px;
                grid-template-columns: 40px 3fr 7fr;
                grid-template-areas:
                    '. . .'
                    '. . content'
                    '. . .';
            }

            :host([catalog]) #heroContent {
                grid-template-columns: 40px 4fr 6fr;
                grid-template-areas:
                    '. . .'
                    '. . content'
                    '. . .';
            }

            :host([left]) #heroContent {
                grid-template-columns: 7fr 3fr 40px;
                grid-template-areas:
                    '. . .'
                    'content . .'
                    '. . .';
            }

            @media only screen and (max-width: 767px) {
                /* For mobile phones: */

                :host #heroContent {
                    display: grid;

                    padding: 0 15px;
                    width: calc(100% - 30px);

                    grid-template-rows: 15px auto 15px !important;
                    grid-template-columns: 1fr !important;
                    grid-template-areas:
                        '.'
                        'content'
                        '.';
                }
            }

            #heroContentCard {
                background: var(--contentcolor);
                border: none;
                border-top-right-radius: 20px;
                border-bottom-right-radius: 20px;
                border-bottom-left-radius: 20px;
                padding: 20px;
                grid-area: content;
                backdrop-filter: blur(2px);
            }

            :host([hidden]),
            [hidden] {
                display: none;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentHeroHeader.prototype, "image", void 0);
__decorate([
    property({ type: Number })
], SDBContentHeroHeader.prototype, "height", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentHeroHeader.prototype, "noContent", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentHeroHeader.prototype, "catalog", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentHeroHeader.prototype, "left", void 0);
SDBContentHeroHeader = __decorate([
    customElement('sdb-content-heroheader')
], SDBContentHeroHeader);
export { SDBContentHeroHeader };
//# sourceMappingURL=sdb-content-heroheader.js.map